export var popoverDefaultValues = {
  showContainerPointer: true
};